import React from "react";
import CheckGreen from "../images/check-icon.png";
import CancelIcon from "../images/cancel-icon.png";
import incomingIcon from "../images/incoming-icon.png";

export default function CheckWithDate(props) {
  const statusClass =
    props.checked === true
      ? "status-signed"
      : props.checked === false
      ? "status-not-signed"
      : "status-pending";

  return (
    <div
      className={`container-check-with-name ${statusClass}`}
      title={`Revoked by: ${props.title}`}
      style={{ cursor: "pointer" }}
    >
      {props.checked === true ? (
        <img
          style={{
            width: "24px",
            height: "24px",
          }}
          alt=""
          src={CheckGreen}
        />
      ) : props.checked === false ? (
        <img
          style={{
            width: "24px",
            height: "24px",
          }}
          alt=""
          src={CancelIcon}
        />
      ) : (
        <img
          style={{
            width: "24px",
            height: "24px",
          }}
          alt=""
          src={incomingIcon}
        />
      )}

      <div className="name-for-check">{props.content} </div>
    </div>
  );
}
